export const sortBonusesByAvailabilityAndAmount = (a, b) => {
  if (a.disabled !== b.disabled) {
    return (a.disabled ? 1 : 0) - (b.disabled ? 1 : 0);
  }

  return (b.financeData?.maxBonusAmount ?? 0) - (a.financeData?.maxBonusAmount ?? 0);
};

export const isAmountBelowMinDeposit = (amountValue, minDeposit) => {
  const amount = Number(amountValue);

  if (
    amountValue === '' ||
    amountValue === null ||
    amountValue === undefined ||
    Number.isNaN(amount) ||
    amount <= 0
  ) {
    return false;
  }

  return amount < minDeposit;
};

export const isDepositBonus = (type, depositBonusTypes) => depositBonusTypes.includes(type);
export const isDepositFreeSpin = (subtype, freeSpinSubTypes) => freeSpinSubTypes.includes(subtype);
export const isCasinoBonus = (productType, casinoProductType) => productType === casinoProductType;

export const getBonusNotAllowedPaymentMethods = bonus => {
  const paymentMethods = bonus?.notAllowedPaymentMethods ?? bonus?.bonus?.notAllowedPaymentMethods;

  return Array.isArray(paymentMethods) ? paymentMethods : [];
};

export const getBonusNotAllowedCountries = bonus => {
  const countries = bonus?.notAllowedCountries ?? bonus?.bonus?.notAllowedCountries;

  return Array.isArray(countries) ? countries : [];
};

export const isBonusAllowedForPaymentMethod = (bonus, paymentMethodId) => {
  if (!bonus || !paymentMethodId) {
    return true;
  }

  return !getBonusNotAllowedPaymentMethods(bonus).map(String).includes(String(paymentMethodId));
};

export const markBonusAvailability = (bonus, isBonusAllowed) =>
  Object.assign(bonus, {
    disabled: !isBonusAllowed(bonus),
  });

export const getMinDeposit = (bonus, currency) =>
  (bonus?.financeDataList ?? bonus?.bonus?.financeDataList ?? []).find(
    item => item.currency === currency,
  )?.minDeposit ??
  bonus?.financeData?.minDeposit ??
  bonus?.bonus?.financeData?.minDeposit ??
  bonus?.freeSpinMinAmountsDeposit?.[currency] ??
  0;

export const normalizePath = path => {
  let end = path.length;
  while (end > 0 && path[end - 1] === '/') {
    end -= 1;
  }
  return path.slice(0, end);
};

export const escapeRegExp = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
// this preselected functionality needs to be changed according to the bonus preselected requirements
export const findPreselectBonus = (list, target) => {
  if (!target) return null;
  const { bonusId, bonusInstanceId } = target;

  if (bonusInstanceId != null) {
    const byInstance = list.find(item => !item.disabled && item.id === bonusInstanceId);
    if (byInstance) return byInstance;
  }

  if (bonusId != null) {
    return (
      list.find(
        item => !item.disabled && (item.id === bonusId || item.bonusTemplateId === bonusId),
      ) || null
    );
  }

  return null;
};

export const isAmountEmptyOrBelowMinDeposit = (amountValue, minDeposit) => {
  const amount = Number(amountValue);

  if (
    amountValue === '' ||
    amountValue === null ||
    amountValue === undefined ||
    Number.isNaN(amount) ||
    amount <= 0
  ) {
    return true;
  }

  return amount < minDeposit;
};
